import React from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './style';

export const Footer = () => {
  const { t } = useTranslation();

  return (
    <S.Footer>
      <S.FooterMenu>
        {t('supportMail') && (
          <>
            <S.SupportLink
              href={`mailto:${t('supportMail')}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('support')}
            </S.SupportLink>
            -
          </>
        )}
        <S.FooterItem href={t('termsOfUseUrl')} target="_blank" rel="noopener noreferrer">
          {t('terms')}
        </S.FooterItem>
        -
        <S.FooterItem href={t('privacyPolicyUrl')} target="_blank" rel="noopener noreferrer">
          {t('privacy')}
        </S.FooterItem>
        <p>-</p>
        <S.FooterItem
          href={t('accessibilityStatementUrl')}
          target="_blank"
          rel="noopener noreferrer"
        >
          {t('accessibilityStatement')}
        </S.FooterItem>
      </S.FooterMenu>
      <S.FooterCopyright>
        {t('copyrightMessage', { year: new Date().getFullYear() })}
      </S.FooterCopyright>
    </S.Footer>
  );
};
